import { shallowEqual } from './shallowEqual';

export const mixStore = (store, action) => {
  riot.mixin({
    init() {
      const tag = this;
      this.connect = (mapState) => {
        let mappedState = mapState(store.getState());
        Object.assign(tag, mappedState);
        tag.update();
        const onStoreChange = state => {
          const newMappedState = mapState(state);
          if (!shallowEqual(newMappedState, mappedState)) {
            mappedState = newMappedState;
            tag.update(newMappedState);
          }

          mappedState = newMappedState;
        };

        store.on('change', onStoreChange);
        tag.on('unmount', () => {
          store.off('change', onStoreChange);
        });
      };
    },
    action
  })
}